import React from 'react';
import { Home, AlertCircle } from 'lucide-react';

interface NotFoundProps {
  onNavigateHome: () => void;
}

export function NotFound({ onNavigateHome }: NotFoundProps) {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="bg-gray-800 rounded-lg p-8 shadow-xl border border-gray-700">
          <AlertCircle className="w-20 h-20 text-orange-500 mx-auto mb-6" />

          <h1 className="text-6xl font-bold text-white mb-4">404</h1>

          <h2 className="text-2xl font-semibold text-white mb-4">
            Strona nie znaleziona
          </h2>

          <p className="text-gray-400 mb-8">
            Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
          </p>

          <button
            onClick={onNavigateHome}
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            <Home className="w-5 h-5" />
            Wróć na stronę główną
          </button>
        </div>

        <p className="text-gray-500 text-sm mt-6">
          Jeśli problem się powtarza, skontaktuj się z nami.
        </p>
      </div>
    </div>
  );
}
